import { useEffect, useState } from "react";
import { Pencil, UserPlus } from "lucide-react";
import { format, parseISO } from "date-fns";
import api from "@/lib/api";
import { CoachStageStepper, ProposalComments, ProposalHistory } from "./CoachStages";

export function MyCoachProposals({ onEdit, refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/proposals/mine").then(r => setRows(r.data.filter(p => p.kind === "coach"))).catch(() => {}); }, [refreshKey]);
  const update = (np) => setRows(rs => rs.map(x => x.id === np.id ? np : x));
  if (!rows.length) return null;
  return (
    <div className="mb-8 space-y-3" data-testid="my-coach-proposals">
      <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B] inline-flex items-center gap-2"><UserPlus className="w-3.5 h-3.5" /> Your coach registrations</div>
      {rows.map(p => (
        <div key={p.id} className={`card-tactical rounded-md p-4 border ${p.status === "rejected" ? "border-red-400/40" : p.status === "approved" ? "border-[#83B68B]/40" : "border-border"}`} data-testid={`my-proposal-${p.id}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <div className="font-display font-bold text-lg">{p.payload.first_name} {p.payload.last_name} <span className="text-xs opacity-60 font-normal">· {p.payload.age_group || "age group TBC"}</span></div>
              <div className="text-[10px] opacity-50 tracking-widest uppercase mt-0.5">Submitted {format(parseISO(p.created_at), "d MMM yyyy")}{p.decided_at ? ` · ${p.status} ${format(parseISO(p.decided_at), "d MMM")}` : ""}</div>
            </div>
            {p.status === "pending" && (
              <button type="button" onClick={() => onEdit(p)} className="text-[10px] tracking-widest uppercase px-3 py-1.5 rounded border border-border hover:border-[#83B68B] hover:text-[#83B68B] inline-flex items-center gap-1" data-testid={`my-proposal-edit-${p.id}`}><Pencil className="w-3 h-3" /> Add / edit details</button>
            )}
          </div>
          <div className="mt-3"><CoachStageStepper stage={p.stage} status={p.status} /></div>
          {p.decision_notes && <div className="mt-2 text-xs opacity-80"><span className="opacity-60">Admin note:</span> {p.decision_notes}</div>}
          <ProposalHistory p={p} />
          <ProposalComments p={p} compact onChanged={update} />
        </div>
      ))}
    </div>
  );
}
